import React, { useEffect, useRef } from "react";
import io from "socket.io-client";
import { AlertFilled } from "@ant-design/icons";
import buzzerSoundFile from "../Assets/buzzer.mp3";
import { Button, Tooltip } from "antd";

const BuzzerComponent = ({ caseId, isSessionActive, currentUserRole }) => {
	const socket = useRef(
		io("https://backend-kyw8.onrender.com/cases", {
			autoConnect: false, // Prevent automatic connection on import
			extraHeaders: {
				case_id: caseId,
			},
		})
	);

	useEffect(() => {
		if (isSessionActive) {
			socket.current.connect();
			console.log("Buzzer connected");

			// Join the case room
			socket.current.on("connect", () => {
				socket.current.emit("join-room", caseId);
			});

			socket.current.on("objection", () => {
				const buzzerSound = new Audio(buzzerSoundFile);
				buzzerSound
					.play()
					.catch((error) => console.error("Audio play failed:", error));

				const event = new CustomEvent("objection-triggered");
				window.dispatchEvent(event);
			});

			return () => {
				socket.current.off("objection");
				socket.current.off("connect");
				// eslint-disable-next-line react-hooks/exhaustive-deps
				socket.current.disconnect();
				console.log("Buzzer disconnected");
			};
		}
	}, [isSessionActive, caseId]);

	const handlePlayButtonClick = () => {
		if (!caseId) return;

		// Play buzzer sound
		const buzzerSound = new Audio(buzzerSoundFile);
		buzzerSound
			.play()
			.catch((error) => console.error("Audio play failed:", error));

		// Emit event with only the `caseId` as expected by the server
		socket.current.emit("objection", caseId);

		// Dispatch custom event for UI updates
		const event = new CustomEvent("objection-triggered");
		window.dispatchEvent(event);
	};

	return (
		<div>
      {currentUserRole === "COUNSEL" && (
        <Tooltip title="OBJECTION!!!">
          <Button
            icon={<AlertFilled />}
            style={{ backgroundColor: "red", color: "white" }}
            onClick={handlePlayButtonClick}
          />
        </Tooltip>
      )}
		</div>
	);
};

export default BuzzerComponent;
